export enum TemplatePluginType {
  Applet = 'type-applet',
  Article = 'type-article',
  Course = 'type-course',
  Event = 'type-event',
  Page = 'type-page',
  Taxonomy = 'type-taxonomy',
  TextExercise = 'type-text-exercise',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Exercise = 'type-text-exercise',
  TextExerciseGroup = 'type-text-exercise-group',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ExerciseGroup = 'type-text-exercise-group',
  Video = 'type-video',
  User = 'type-user',
  GenericContent = 'type-generic-content',
}
